import { toast } from "react-toastify";

export type ErrorType = "API" | "VALIDATION" | "AUTHENTICATION" | "UNKNOWN";

export interface AppError extends Error {
  type: ErrorType;
  statusCode?: number;
  details?: any;
}

class ErrorHandler {
  private static instance: ErrorHandler;

  private constructor() {}

  public static getInstance(): ErrorHandler {
    if (!ErrorHandler.instance) {
      ErrorHandler.instance = new ErrorHandler();
    }
    return ErrorHandler.instance;
  }

  public handleError(error: Error | AppError): void {
    if (this.isAppError(error)) {
      this.handleAppError(error);
    } else {
      this.handleGenericError(error);
    }
  }

  private isAppError(error: Error | AppError): error is AppError {
    return "type" in error;
  }

  private handleAppError(error: AppError): void {
    switch (error.type) {
      case "API":
        this.handleAPIError(error);
        break;
      case "VALIDATION":
        this.handleValidationError(error);
        break;
      case "AUTHENTICATION":
        this.handleAuthenticationError(error);
        break;
      default:
        this.handleGenericError(error);
    }
  }

  private handleAPIError(error: AppError): void {
    toast.error(`API Error: ${error.message}`);
    // Log to monitoring service
    console.error("API Error:", error);
  }

  private handleValidationError(error: AppError): void {
    toast.warning(`Validation Error: ${error.message}`);
    console.warn("Validation Error:", error);
  }

  private handleAuthenticationError(error: AppError): void {
    toast.error(`Authentication Error: ${error.message}`);
    // Redirect to login or handle auth failure
    console.error("Auth Error:", error);
  }

  private handleGenericError(error: Error): void {
    toast.error(`An unexpected error occurred: ${error.message}`);
    console.error("Generic Error:", error);
  }
}

export const errorHandler = ErrorHandler.getInstance();
